import React from 'react';
import { Flex } from '@/hen-ui/composites';
import { COMPONENT_IDS } from '@/hen-ui/catalog/component-ids';

/**
 * Internal container for FeedbackBox. Uses EDU Design System tokens only:
 * - Background: secondary-50 (purple/lavender)
 * - Padding: space token (p-b1)
 * - Border radius: rounded-sm (8px per spec)
 * - Gap: gap-sm
 */
interface FeedbackBoxContainerProps extends React.PropsWithChildren {}

export const FeedbackBoxContainer: React.FC<FeedbackBoxContainerProps> = ({
  children,
}) => (
  <Flex
    className='bg-secondary-50 p-4 rounded-sm'
    direction='row'
    align='start'
    gap='sm'
    data-hen-id={COMPONENT_IDS.FeedbackBox}
  >
    {children}
  </Flex>
);
